import { Container, Button, Modal, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import VideocamIcon from "@mui/icons-material/Videocam";
import ClearIcon from "@mui/icons-material/Clear";
import PersonalImage from "../../helpers/fileUpload";
import Card from "react-bootstrap/Card";
import { publishImage } from "../../helpers/imageupload";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useDropzone } from "react-dropzone";
import url from "../../config/axios";
import { getAsset } from "../../helpers/helper";
import { useSelector } from "react-redux";

const Photovideoupdate = ({
  show,
  CreatePostSubmit,
  createPost,
  setCreatePost,
  setUpdatepost,
  timelineid,
  postId,
  id,
  UpdatePost,
  setUpdatedata,
  updatedata,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const { name } = useSelector((state) => state.user);
  const [businesstypes, setBusinessTypes] = useState();

  const handleValue = (e) => {
    setUpdatedata((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const removeImage = (index) => {
    setUploadedImages((prev) => prev.filter((_, i) => i !== index));
    setUpdatedata((prevState) => ({
      ...prevState,
      img: (prevState.img || []).filter((_, i) => i !== index),
    }));
  };

  const removeVideo = (index) => {
    setUploadedVideos((prev) => prev.filter((_, i) => i !== index));
    setUpdatedata((prevState) => ({
      ...prevState,
      video: (prevState.video || []).filter((_, i) => i !== index),
    }));
  };

  const onDropport = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setUpdatedata((prevState) => ({
        ...prevState,
        img: abc, // Update img with the new array of images
      }));
      setUploadedImages((abc || []).map((p) => getAsset(p)));
    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
  };

  const onDropvideo = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setUpdatedata((prevState) => ({
        ...prevState,
        video: abc, // Update video with the new array of videos
      }));
      setUploadedVideos((abc || []).map((p) => getAsset(p)));
    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
  };

  const { getRootProps: getRootPropsPort, getInputProps: getInputPropsPort } =
    useDropzone({
      accept: "image/*",
      onDrop: onDropport,
    });

  const { getRootProps: getRootPropsVideo, getInputProps: getInputPropsVideo } =
    useDropzone({
      accept: "video/*",
      onDrop: onDropvideo,
    });

  // `postId` is shared state also used by other post actions (comment,
  // share, etc). Those actions update `postId` too, but they don't mean
  // the user wants to edit the post — so only fetch/fire errors here when
  // the Update modal is actually meant to be open (`show === true`).
  // Otherwise a share/comment click on a post this modal can't resolve
  // (e.g. a post shared to you, not one of "my" own posts) would
  // incorrectly surface an "update" error toast.
  useEffect(() => {
    if (show && postId) {
      const params = new URLSearchParams();
      params.append("userid", name._id);
      if (id) params.append("shopid", id);
      params.append("postid", postId);

      url
        .get(`timeline/getSingleTimeline?${params.toString()}`)
        .then((response) => {
          const resp = response?.data;
          // server responds { success: true, data: post }
          const post = resp?.data || resp;
          setUpdatedata(post || {});
          setBusinessTypes(post?.businessType);
          const imgs = (post?.img || []).map((p) => getAsset(p));
          const videos = (post?.video || []).map((p) => getAsset(p));
          setUploadedImages(imgs);
          setUploadedVideos(videos);
        })
        .catch(() => {
          FailedNotify("Failed to load post data for update");
        });
    }
  }, [show, id, name, timelineid, postId]);

  return (
    <>
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Container>
        <Modal
          show={show}
          onHide={() => setUpdatepost(false)}
          animation={false}
        >
          <Modal.Header closeButton className="font-sm">
            <Modal.Title>
              <h6 className="m-0">Update Photos/Videos</h6>
            </Modal.Title>
          </Modal.Header>

          <Form.Group className="mt-3 ps-3 pe-3" controlId="formBasicEmail">
            <Form.Control
              type="text"
              onChange={(e) => handleValue(e)}
              name="heading"
              value={updatedata?.heading || ""}
            />
          </Form.Group>
          <Modal.Body>
            <div className="form-group">
              <textarea
                className="form-control"
                rows="3"
                name="content"
                placeholder="Write something...."
                onChange={(e) => handleValue(e)}
                value={updatedata?.content || ""}
              />
            </div>
            <div className="d-flex justify-content-end mt-2">
              <div className="text-warning me-2" {...getRootPropsPort()}>
                <CameraAltIcon className="cur-pointer" />
                <input
                  type="file"
                  id="file"
                  name="img"
                  style={{ display: "none" }}
                  {...getInputPropsPort()}
                  multiple
                />
              </div>{" "}
              <div className="text-success" {...getRootPropsVideo()}>
                <VideocamIcon className="cur-pointer" />
                <input
                  type="file"
                  style={{ display: "none" }}
                  name="video"
                  {...getInputPropsVideo()}
                />
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {uploadedImages.map((image, index) => (
                <Card
                  key={index}
                  style={{
                    width: "auto",
                    height: "auto",
                    border: "1px solid #ccc",
                    padding: "2px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Card.Img
                    className="imet-fit upload-img"
                    src={image}
                    alt={`Uploaded ${index}`}
                  />
                  <div
                    className="close-btnone"
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      zIndex: 2,
                      cursor: "pointer",
                      background: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      width: 22,
                      height: 22,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => removeImage(index)}
                  >
                    <ClearIcon style={{ color: "#fff", fontSize: 16 }} />
                  </div>
                </Card>
              ))}

              {uploadedVideos.map((video, index) => (
                <Card
                  key={`video-${index}`}
                  style={{
                    width: "50%",
                    height: "50%",
                    border: "1px solid #ccc",
                    padding: "2px",
                    overflow: "hidden",
                    position: "relative",
                    background: "#ccc",
                  }}
                >
                  <video
                    src={video}
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  <div
                    className="close-btnone"
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      zIndex: 2,
                      cursor: "pointer",
                      background: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      width: 22,
                      height: 22,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => removeVideo(index)}
                  >
                    <ClearIcon style={{ color: "#fff", fontSize: 16 }} />
                  </div>
                </Card>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <Button onClick={() => setUpdatepost(false)} className="cancle-btn">
              Cancel
            </Button>
            <Button className="post-btn" onClick={UpdatePost}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default Photovideoupdate;
